import { setupCookieConsent } from './monolith-consent';

interface ConsentEnabledWindow {
  __akCookieConsentEnabled?: boolean;
}

/**
 * Initialises the self-hosted cookie consent banner only when the server enabled
 * it. The `consent-mode-default` Blade partial renders (and sets
 * `window.__akCookieConsentEnabled`) exactly when `$showCookieBanner` is true.
 * Gating on that single marker keeps the JS in lock-step with the Blade decision:
 * the banner stays suppressed in the embedded `widget` layout (showCookieBanner=false).
 */
export async function bootstrapCookieConsent(): Promise<void> {
  if (!(globalThis as unknown as ConsentEnabledWindow).__akCookieConsentEnabled) {
    return;
  }
  await setupCookieConsent();
}
